import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accEntryViewByPage = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] BASE',
  async ({ page, ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view(page, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryViewBase = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] BASE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('view', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewDetails = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_DETAILS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewdetails', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewOID = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_OID',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewoid', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewConv = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_CONV',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewconv', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewHistory = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_HISTORY',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewhistory', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewConventries = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_CONVENTRIES',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewdetails', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryViewUCC = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_UCC',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view('viewucc', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryOrderInitialFields = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_UCC_INITAL_FIELDS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view(null, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const printOrder = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] VIEW_UCC',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.view(params.page, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const destroyAccEntryInitialFields = createAction('[ACC_ENTRY] DESTROY_VIEW_UCC_INITAL_FIELDS')
